export * from '@app/advisor-shared';
export * from './ModuleFE_SandboxNLP.js';
export * from './templates.js';
//# sourceMappingURL=index.js.map